import React, { useState, useEffect } from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";
import ShareModal from "../../molecules/share-modal/shareModal";
import { getLikes, addLike } from "../../../../contentful/CMS";
import Breadcrumb from "../../atoms/breadcrumb/breadcrumb";
import "./headboardButtons.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import { GatsbyImage } from "gatsby-plugin-image";
const HeadboardButtons = (props: ReferenciaCabecera) => {
  const { isBrowser, localStorage } = useBrowserMode();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [likes, setLikes] = useState(-1);
  const [isLikeButtonDisabled, setIsLikeButtonDisabled] = useState(true);
  const doLike = () => {
    const getData = async () => {
      const res = await getLikes(props.contentful_id);
      if (res === undefined) {
        return;
      }
      if (
        isBrowser &&
        localStorage.getItem(`comfama:likedArticle.${props.contentful_id}`) ===
          "true"
      ) {
        setIsLikeButtonDisabled(true);
        setLikes(res);
        return;
      }
      setLikes(res);
      setIsLikeButtonDisabled(false);
    };

    getData();
  };
  useEffect(() => {
    doLike();
  }, []);
  const toggleModal = () => {
    setIsModalVisible(!isModalVisible);
  };

  const handleOnLikeClick = async () => {
    setIsLikeButtonDisabled(true);
    const res = await getLikes(props.contentful_id);
    await addLike(props.contentful_id, res);
    setLikes(res + 1);
    isBrowser &&
      localStorage.setItem(
        `comfama:likedArticle.${props.contentful_id}`,
        "true"
      );
  };

  return (
    <div className="o-headboard-btns">
      <Breadcrumb
        content={`Inicio / Biblioteca de Contenidos / ${props.migaDePan}`}
      />
      <div className="o-headboard-btns__cont">
        <div className="o-headboard-btns__cont__content">
          <h1 className="o-headboard-btns__cont__content__title">
            {props.tituloPrincipal}
          </h1>
          <article className="o-headboard-btns__cont__content__text">
            {props.descripcion
              ? documentToReactComponents(JSON.parse(props?.descripcion?.raw))
              : ""}
          </article>
          <ul className="o-headboard-btns__tabs-btns">
            <li>
              <button
                className={`o-headboard-btns__tabs-btns-btn 
                gtmRedDeAmor${normalizeTwoWords(
                  props.tituloPrincipal
                )}EncabezadoMeGusta    o-headboard-btns__tabs-btns-btn `}
                onClick={(e) => {
                  handleOnLikeClick();
                  e.preventDefault();
                }}
                disabled={isLikeButtonDisabled}
              >
                <i
                  className={`${
                    likes !== -1 &&
                    (isLikeButtonDisabled ? "icon-heart" : "icon-heart1")
                  } `}
                ></i>
                {likes !== -1 &&
                  (isLikeButtonDisabled
                    ? `Te gusta - ${likes} ${likes === 1 ? "voto" : "votos"}`
                    : `${likes} Me gusta`)}
              </button>
            </li>
            <li>
              <ShareModal open={isModalVisible} onClose={toggleModal} />
              <button
                className={`gtmRedDeAmor${normalizeTwoWords(
                  props.tituloPrincipal
                )}EncabezadoCompartir  o-headboard-btns__tabs-btns-btn ${
                  isModalVisible ? "activebutton" : "no-activebutton"
                }`}
                onClick={toggleModal}
              >
                <i className={`icon-share1`}></i>
                Compartir
              </button>
            </li>
          </ul>
        </div>
        <div className="o-headboard-btns__cont__cover">
          <GatsbyImage
            className="o-headboard-btns__cont__cover__img"
            src={props.imagenHeader.gatsbyImageData}
            alt={props.imagenHeader.title || "imagen cabecera botones"}
          />
        </div>
      </div>
    </div>
  );
};

export default HeadboardButtons;
